import * as actionTypes from "./types";

const initialState = {
  loading: false,
  sucess: false,
  error: null,
  trans_list: null,
  refundlist: null,
  refundHistoryList: null
};

const listTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LIST_TRANSACTION_INITIATED: {
      return { ...state, loading: true };
    }
    case actionTypes.LIST_TRANSACTION_SUCCESS: {
      return {
        ...state,
        loading: false,
        trans_list: action.payload,
        success: true,
        error: null,
      };
    }
    case actionTypes.LIST_TRANSACTION_FAILED: {
      return {
        ...state,
        loading: false,
        trans_list: null,
        success: false,
        error: action.payload,
      };
    }

    /* Refund List  */
    case actionTypes.LIST_REFUND_INITIATED: {
      return { ...state, loading: true };
    }
    case actionTypes.LIST_REFUND_SUCCESS: {
      return {
        ...state,
        loading: false,
        refundlist: action.payload,
        success: true,
        error: null,
      };
    }
    case actionTypes.LIST_REFUND_FAILED: {
      return {
        ...state,
        loading: false,
        refundlist: null,
        success: false,
        error: action.payload,
      };
    }

    /* Refund History List  */
    case actionTypes.LIST_REFUND_HISTORY_INITIATED: {
      return { ...state, loading: true };
    }
    case actionTypes.LIST_REFUND_HISTORY_SUCCESS: {
      return {
        ...state,
        loading: false,
        refundHistoryList: action.payload,
        success: true,
        error: null,
      };
    }
    case actionTypes.LIST_REFUND_HISTORY_FAILED: {
      return {
        ...state,
        loading: false,
        refundHistoryList: null,
        success: false,
        error: action.payload,
      };
    }
    
    default: {
      return state;
    }
  }
};

export default listTransactionReducer;
